<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: [Number, String],
    default: 14
  },
  class: {
    type: String,
    default: ''
  },
  clipped: {
    type: Boolean,
    default: true
  }
});

//avoid conflict
const gradientId = computed(() => `messenger-gradient-${Math.random().toString(36).substr(2, 9)}`);

const clipPath = computed(() => {
  if (!props.clipped) return '';
  const radius = props.size / 2;
  return `circle(${radius}px at ${radius}px ${radius}px)`;
});
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 256 256"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    style="display:block;"
    :class="class"
    :clip-path="clipPath"
  >
    <defs>
      <radialGradient :id="gradientId" cx="19.247%" cy="99.465%" r="108.96%" fx="19.247%" fy="99.465%">
        <stop offset="0%" stop-color="#09F"/>
        <stop offset="60.975%" stop-color="#A033FF"/>
        <stop offset="93.482%" stop-color="#FF5280"/>
        <stop offset="100%" stop-color="#FF7061"/>
      </radialGradient>
    </defs>
    <path :fill="`url(#${gradientId})`" d="M128 0C55.894 0 0 52.818 0 124.16c0 37.317 15.293 69.562 40.2 91.835 2.09 1.871 3.352 4.493 3.438 7.298l.697 22.77c.223 7.262 7.724 11.988 14.37 9.054L84.111 243.9a10.218 10.218 0 0 1 6.837-.501c11.675 3.21 24.1 4.92 37.052 4.92 72.106 0 128-52.818 128-124.16S200.106 0 128 0Z"/>
    <path fill="#FFF" d="m51.137 160.47 37.6-59.653c5.98-9.49 18.788-11.853 27.762-5.123l29.905 22.43a7.68 7.68 0 0 0 9.252-.027l40.388-30.652c5.39-4.091 12.428 2.36 8.82 8.085l-37.6 59.654c-5.981 9.489-18.79 11.852-27.763 5.122l-29.906-22.43a7.68 7.68 0 0 0-9.25.027l-40.39 30.652c-5.39 4.09-12.427-2.36-8.818-8.085Z"/>
  </svg>
</template>